export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCQ6FygXxCZVUr9FNa3gH3tsn-dHxkRE2s',
    authDomain: 'card-engine.firebaseapp.com',
    databaseURL: 'https://card-engine.firebaseio.com',
    projectId: 'card-engine',
    storageBucket: 'card-engine.appspot.com',
    messagingSenderId: '999664097706',
    appId: '1:999664097706:web:1f6c90117c4556c44e73d3',
    measurementId: 'G-FPJG0J3PX0'
    /* cardEngine: {
      maxLogSize: 150
    } */
  }
};
